module.exports = __webpack_public_path__ + "img/Delivery location Icon - white.fc41aa0e.svg";